/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type TrustedMemberPageContentModelContentType = typeof TrustedMemberPageContentModelContentType[keyof typeof TrustedMemberPageContentModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrustedMemberPageContentModelContentType = {
  trustedMemberPage: 'trustedMemberPage',
} as const;
